// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore.js";
import "./sceneUboDeclaration.js";
var name = "geometryUboDeclaration";
var shader = "#include<sceneUboDeclaration>\n";
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export var geometryUboDeclaration = { name: name, shader: shader };
//# sourceMappingURL=geometryUboDeclaration.js.map